import { useDarkMode } from '../contexts/DarkModeContext'
import { useUserPreferences } from '../contexts/UserPreferencesContext'
import {
  RADIUS_CIRCLE_STYLE_OPTS,
  LIGHT_RADIUS_CIRCLE_STYLE_OPTS,
  DEADBAND_CIRCLE_STYLE_OPTS,
  LIGHT_DEADBAND_CIRCLE_STYLE_OPTS,
  LIGHT_CLUSTER_CIRCLE_STYLE_OPTS,
  CLUSTER_CIRCLE_STYLE_OPTS,
  LIGHT_PATTERN_CIRCLE_STYLE_OPTS,
  PATTERN_CIRCLE_STYLE_OPTS,
} from '../utils/constants/map.constants'

interface MarkerStyles {
  radiusStyle: typeof RADIUS_CIRCLE_STYLE_OPTS
  deadbandStyle: typeof DEADBAND_CIRCLE_STYLE_OPTS
  clusterStyle: typeof CLUSTER_CIRCLE_STYLE_OPTS
  patternStyle: typeof PATTERN_CIRCLE_STYLE_OPTS
}

export const useAgamiMarkerStyle = (): MarkerStyles => {
  const { mapStyle } = useUserPreferences()
  const { darkMode } = useDarkMode()
  const lightMarker = mapStyle === 'satellite' || darkMode
  return {
    radiusStyle: lightMarker ? LIGHT_RADIUS_CIRCLE_STYLE_OPTS : RADIUS_CIRCLE_STYLE_OPTS,
    deadbandStyle: lightMarker ? LIGHT_DEADBAND_CIRCLE_STYLE_OPTS : DEADBAND_CIRCLE_STYLE_OPTS,
    clusterStyle: lightMarker ? LIGHT_CLUSTER_CIRCLE_STYLE_OPTS : CLUSTER_CIRCLE_STYLE_OPTS,
    patternStyle: lightMarker ? LIGHT_PATTERN_CIRCLE_STYLE_OPTS : PATTERN_CIRCLE_STYLE_OPTS,
  }
}
